export default [
    { name: 'Active' },
    { name: 'Inactive' },
];
